import React, { Component } from 'react'
import { Box } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import useStyles from './styles/SectionTitle'

class SectionTitle extends Component {
  render() {
    return (
      <Box className={'section-title'}>
          {this.props.title.toUpperCase()}
      </Box>
    )
  }
}

export default withStyles(useStyles)(SectionTitle)
